import AutoVoidModal from './auto-void-modal';

export * from './functions';
export default AutoVoidModal;
